<section class="ks-context" data-testid="context-block">
  <h3 class="ks-context__title">Tell us about your business <span>(optional)</span></h3>

  @if (open()) {
    <p class="ks-context__note">
      Anything that helps us understand the business and these documents.
    </p>
    <div class="ks-context__prompts" role="group" aria-label="Starter prompts">
      @for (label of CONTEXT_PROMPTS; track label) {
        <button
          type="button"
          class="ks-context__prompt"
          (click)="pressPrompt(label)"
          [attr.data-testid]="'prompt-' + label"
        >
          {{ label }}
        </button>
      }
    </div>
    <mat-form-field appearance="outline" class="ks-context__field">
      <mat-label>In your own words</mat-label>
      <textarea
        matInput
        rows="6"
        [value]="text()"
        (input)="text.set($any($event.target).value)"
        data-testid="context-text"
      ></textarea>
      <mat-hint align="end">{{ text().length }} characters</mat-hint>
    </mat-form-field>
    <p class="ks-context__note">
      This doesn't change what you qualify for — it changes how well we understand what we're
      looking at.
    </p>
    <p class="ks-context__note">
      What you add here is read with your documents in your assessment, under the business's
      consent to AI assessment. A person always makes the final decision.
    </p>
    <div class="ks-context__actions">
      <button
        mat-stroked-button
        type="button"
        (click)="addNote()"
        [disabled]="!text().trim() || uploading() > 0"
        data-testid="context-add-note"
      >
        Add note
      </button>
      <label class="ks-context__file">
        <input type="file" multiple (change)="onFiles($event)" data-testid="context-file" />
        <app-icon name="upload" [size]="16" />
        <span>Add documents — any kind</span>
      </label>
      @if (uploading() > 0) {
        <mat-spinner diameter="18" />
      }
    </div>
    @if (error(); as err) {
      <p class="ks-context__error" role="alert">{{ err }}</p>
    }
  } @else {
    <!-- DOC-73 UI-DA-73-04: closed once the offer is issued; what was added stays readable. -->
    <p class="ks-context__note" data-testid="context-closed">
      Notes and documents can be added until an offer is issued.
    </p>
  }

  @if (entries().length > 0) {
    <ul class="ks-context__entries" data-testid="context-entries">
      @for (e of entries(); track e.short_id) {
        <li>
          @if (e.text) {
            <span class="ks-context__text">{{ e.text }}</span>
          }
          @if (e.file_name) {
            <span><app-icon name="file-text" [size]="15" /> {{ e.file_name }}</span>
          }
          <span class="ks-context__muted"
            >Added by {{ e.entered_by_name }} · {{ e.created_at | date: 'd MMM y, HH:mm' }}</span
          >
        </li>
      }
    </ul>
  }
</section>
